import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Navbar } from 'react-bootstrap';

import { apiHost } from '../../../config';
import { post } from '../../../lib/requests';

export default () => {
  const history = useHistory();

  const logout = async () => {
    try {
      await post(`${apiHost}/api/logout`, {});
      history.push('/login');
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <Navbar
      sticky="top"
      bg="dark"
      variant="dark"
      className="px-5 justify-content-between"
      style={{ height: '56px' }}
    >
      <Navbar.Brand>СПТ {new Date().getFullYear()}</Navbar.Brand>
      <div>
        <span className="text-white" style={{ marginRight: '2rem' }}>{localStorage.username ?? ''}</span>

        <span className="text-white" style={{ marginRight: '2rem' }}>{localStorage.schoolName ?? ''}</span>

        <Button variant="outline-light" onClick={logout}>
          Выйти
        </Button>
      </div>
    </Navbar>
  );
};
